export const QUERY_KEYS = {
  CAMPAIGN_DETAILS: 'campaignDetails',
  CAMPAIGN_PERFORMANCE: 'campaignPerformance',
  CAMPAIGNS_LIST: 'campaignsList',
} as const;
